function convertUnits(inputBox, outputBox, factor) {
            if ((document.getElementById(inputBox).value) <= 0) {
                document.getElementById(inputBox).value = 0
            }
            var feet = parseFloat(document.getElementById(inputBox).value);
            var metres = feet * factor;
            metres = Math.round(metres * 100) / 100;
            document.getElementById(outputBox).value = metres;

        }
        function ConvertToInchesMetres(MyInput, outputBox) {
            var myText = document.getElementById(MyInput).value;

            myText = myText.toString();
            if (myText.includes(',')) {
                const nameArr = myText.split(",");
                var feet = Number(nameArr[0]);
                var inches = Number(nameArr[1]);
            }
            else {
                var inches = Number(myText) * 12;
                var feet = 0;
            }
            document.getElementById(outputBox).value = (((feet * 12) + inches) / 39.37).toFixed(2)

        }

        function updateView() {
            var feetLen = parseFloat(document.getElementById("metLenTextBox").value) * 3.281;
            var feetWid = parseFloat(document.getElementById("metWidTextBox").value) * 3.281;
            var feetHei = parseFloat(document.getElementById("metHeiTextBox").value) * 3.281;
            var roomTypeVal = document.getElementById("roomType").value;
            var BTU = feetLen * feetWid * feetHei * roomTypeVal;
            var fenchWin
            if (document.getElementById("frenchWindowsBox").checked == true) {
                frenchWin = BTU * 0.2;
            }
            else {
                frenchWin = 0;
            }
            var northFace
            if (document.getElementById("northFacingBox").checked == true) {
                northFace = BTU * 0.15;
            }
            else {
                northFace = 0;
            }
            var doubleGlaz;
            if (document.getElementById("doubleGlazingBox").checked == true) {
                doubleGlaz = BTU * 0.1;
            }
            else {
                doubleGlaz = 0;
            }
            BTU = BTU + frenchWin + northFace - doubleGlaz;
            var watts = BTU / 3.41214;
            BTU = Math.round(BTU * 1) / 1;
            watts = Math.round(watts * 1) / 1;

            if (isNaN(BTU)) {
                BTU = 0;
                watts = 0;
            }
            document.getElementById("btuOutput").value = BTU;
            document.getElementById("wattsOutput").value = watts;
            document.getElementById("BTUInTextBox").value = BTU;
            document.getElementById("WattsInTextBox").value = watts;
updateDeltaView()
        }
        function ClearAll() {
            document.getElementById("BTUForm").reset;

        }

        function FeetInchesDecimal(feet, inches) {
            var feet = parseFloat(document.getElementById(feet).value);
            var inches = parseFloat(document.getElementById(inches).value);
            var result = Math.round(feet + (inches / 12), -2);
            return result;

        }
 function ClearBoxes() {
            document.getElementById("BTUInTextBox").value = "";
            document.getElementById("WattsInTextBox").value = "";
            document.getElementById("DbtuOutput").value = "";
            document.getElementById("DwattsOutput").value = "";
            document.getElementById("givenBTUSelected").value = 60;
        }
        function convertBTUWUnits(inputBox, outputBox, factor) {

            if ((document.getElementById(inputBox).value) <= 0) {
            document.getElementById(inputBox).value = 0
        }
            var dInput = parseFloat(document.getElementById(inputBox).value);
            var dOutput = Math.round((dInput * factor) * 1) / 1;
            document.getElementById(outputBox).value = dOutput;
            updateDeltaView()
        }
        function updateDeltaView() {
            var dGivenBTU = parseFloat(document.getElementById("BTUInTextBox").value);
            var dGivenDelta = parseFloat(document.getElementById("givenBTUSelected").value);
            var dConversionFactor
            switch (dGivenDelta) {
                case 5:
                    dConversionFactor = 0.05;
                    break;
                case 10:
                    dConversionFactor = 0.123;
                    break;
                case 15:
                    dConversionFactor =0.209;
                    break;
                case 20:
                    dConversionFactor = 0.304;
                    break;
                case 25:
                    dConversionFactor = 0.406;
                    break;
                case 30:
                    dConversionFactor = 0.515;
                    break;
                case 35:
                    dConversionFactor = 0.629;
                    break;
                case 40:
                    dConversionFactor = 0.748;
                    break;
                case 45:
                    dConversionFactor = 0.872;
                    break;
                case 50:
                    dConversionFactor = 1;
                    break;
                case 55:
                    dConversionFactor = 1.132;
                    break;
                case 60:
                    dConversionFactor = 1.267;
                    break;
                case 65:
                    dConversionFactor = 1.406;
                    break;
                case 70:
                    dConversionFactor = 1.549;
                    break;
                case 75:
                    dConversionFactor = 1.694;
                    break;
            }

            BTU = dGivenBTU / dConversionFactor
            var watts = BTU / 3.41214;
            BTU = Math.round(BTU * 1) / 1;
            watts = Math.round(watts * 1) / 1;
            if (isNaN(BTU))
            {
                BTU = 0;
                watts = 0;
            }
            document.getElementById("DbtuOutput").value = BTU;
            document.getElementById("DwattsOutput").value = watts;
            }